<template>
  <Screen>
    <Portals>
    </Portals>
  </Screen>
</template>

<script>
import Screen from '@/components/Screen'
import Portals from '@/components/Portals'

export default {
  components: {
    Screen,
    Portals
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>
@import url(../../../static/jot.css);
</style>



// WEBPACK FOOTER //
// src/pages/Happy/Happy.vue